module.exports = __webpack_public_path__ + "static/media/meh.244a3e88.svg";